export default {
  name: 'Article list section - 3',
  tab: 'article list',
  type: 'category-listing-default-section',
  content: {
    title: 'Category listing section',
    introtext: '',
    articles:
      '[{"article-title":"Article 1","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 2","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--secondary-color)',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'var(--text-light-color)',
    'article-title-color': 'inherit',
    'article-title-font-weight': 'lighter',
    'article-title-tag': 'h6',
    'article-introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'md',
    'content-horizontal-alignment': 'center',
    'article-columns': '1',
    'content-box': '1',
    'content-box-wrap': 'item',
    'content-box-color': 'var(--background-color)',
    'content-box-padding': '40px',
    'content-box-opacity': '0.16',
    'content-box-elevation': '8',
    'content-box-border': '1',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '1'
  },
  advanced: {}
}
